import React from 'react';
import './MarqueeScroller.css';

function MarqueeScroller({
  items = [
    'DISCRETION',
    'YORKVILLE',
    'ONE TEAM',
    'PREVENTION',
    'PRECISION',
    'CONTINUITY',
    'ADVOCACY',
    'LONGEVITY'
  ],
  separator = '•',
  speed = 30 // Animation duration in seconds (lower is faster)
}) {
  // Duplicate array to ensure seamless infinite looping animation
  const duplicatedItems = [...items, ...items, ...items, ...items];

  return (
    <section className="ttc-marquee-section py-3 border-top border-bottom">
      <div className="ttc-marquee-container">
        <div 
          className="ttc-marquee-track" 
          style={{ animationDuration: `${speed}s` }}
        >
          {duplicatedItems.map((item, index) => (
            <div key={index} className="ttc-marquee-item d-inline-flex align-items-center">
              <span className="ttc-marquee-text">{item}</span>
              <span className="ttc-marquee-separator">{separator}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarqueeScroller;